import { AppShell } from '../components/AppShell'
import { useLeaderboard } from '../lib/api'

function fmtEur(v: string | number): string {
  const n = typeof v === 'string' ? Number(v) : v
  if (!Number.isFinite(n)) return '—'
  const sign = n >= 0 ? '+' : '−'
  return sign + new Intl.NumberFormat('en-IE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(Math.abs(n))
}

export function LeaderboardPage() {
  const q = useLeaderboard()
  const rows = q.data?.rows ?? []
  const selfRank = q.data?.selfRank ?? null

  return (
    <AppShell page="leaderboard" breadcrumb={<span className="topbar__breadcrumb-current">Leaderboard</span>}>
      <header className="page-header">
        <div className="page-header__main">
          <p className="page-header__eyebrow"><span>Community</span></p>
          <h1 className="page-header__title">Leaderboard</h1>
          <p className="page-header__subtitle">
            Funded traders ranked by composite trader score.
            {selfRank && ` Your rank: #${selfRank}.`}
          </p>
        </div>
      </header>

      <section className="table-card" aria-label="Leaderboard">
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Trader</th>
                <th>Tier</th>
                <th className="is-numeric">Score</th>
                <th className="is-numeric">P&amp;L</th>
              </tr>
            </thead>
            <tbody>
              {q.isLoading && (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--text-tertiary)', padding: 'var(--space-5)' }}>Loading…</td></tr>
              )}
              {!q.isLoading && rows.length === 0 && (
                <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--text-tertiary)', padding: 'var(--space-6)' }}>
                  No funded traders yet. Be the first — reach Phase 4 to appear here.
                </td></tr>
              )}
              {rows.map((r) => (
                <tr key={r.accountId} style={r.self ? { background: 'var(--color-primary-subtle)' } : undefined}>
                  <td><span className="numeric" style={{ fontWeight: 600 }}>#{r.rank}</span></td>
                  <td>{r.displayName}{r.self ? ' (you)' : ''}</td>
                  <td><span className="chip">{r.tierCode.charAt(0).toUpperCase() + r.tierCode.slice(1)}</span></td>
                  <td className="is-numeric">{r.score.toFixed(1)}</td>
                  <td className="is-numeric">
                    <span className={'pnl-value ' + (Number(r.pnlEur) >= 0 ? 'pnl-value--positive' : 'pnl-value--negative')}>
                      {fmtEur(r.pnlEur)}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </AppShell>
  )
}
